Ext.ns('mx.comp');

mx.comp.CountrySelectCombo = Ext.extend(mx.comp.LinkedComboBox, {
    labels: {
        country: 'Country',
        emptyText: 'Select a country...',
        blankText: 'Country is a required field',
    },
    fieldLabel: null,
    emptyText: null,
    blankText: null,
    valueField: 'id',
    displayField: 'name',
    url: null,
    initComponent: function() {
        this.fieldLabel = this.labels.country;
        this.emptyText = this.labels.emptyText;
        this.blankText = this.labels.blankText;
        this.store = mx.data.Country.newStore({url: this.url});
        mx.comp.CountrySelectCombo.superclass.initComponent.call(this, arguments);
    },
});

Ext.reg('mx-countrycombo', mx.comp.CountrySelectCombo);
